import { FormBuilder, FormGroup } from '@angular/forms';
import { MyElAderentiA, MyElDichiarSostitEntity, MyElWarningEntity, MyVerbale } from '../../../../models/interfaces/revisione.interface';
import { rebuildFormArray } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';
import { CoopValidators } from '@core/helpers/validators.helper';

export const buildAderentiAFormArray = (fb: FormBuilder, myVerbale: MyVerbale, form: FormGroup, withValidators = true) => {
    const aderentiRevisione = myVerbale?.my_SezioneI__Rilevazione?.my_DatiIdentificativi?.my_AderentiA?.my_ElAderentiA;
    rebuildFormArray(fb, aderentiRevisione, form, `${formPaths.datiIdentificativi}.my_AderentiA.my_ElAderentiA`, (fbInner, item) =>
        buildAderenteAGroup(fbInner, item, withValidators)
    );
};

export const buildAderenteAGroup = (fb: FormBuilder, item?: MyElAderentiA, withValidators = true): FormGroup => {
    const sezVisib = item?.my_SezVisibAderenteA;
    return fb.group({
        my_SezVisibAderenteA: fb.group({
            my_AderenteA: withValidators ? [sezVisib?.my_AderenteA ?? '', CoopValidators.required] : [sezVisib?.my_AderenteA ?? ''],
            my_CkAderenteA: [sezVisib?.my_CkAderenteA ?? ''],
            my_IdAderenteA: [sezVisib?.my_IdAderenteA ?? ''],
            my_aderenteDal: [sezVisib?.my_aderenteDal ?? ''],
        }),
    });
};;

export const buildWarningFormArray = (fb: FormBuilder, myVerbale: MyVerbale, form: FormGroup) => {
    const elWarning = myVerbale.my_Warning.my_ElWarning;
    rebuildFormArray(fb, elWarning, form, 'my_Warning.my_ElWarning', buildWarningGroup);
};

export const buildWarningGroup = (fb: FormBuilder, item?: MyElWarningEntity): FormGroup => {
    return fb.group({
        my_DescWarning: item?.my_DescWarning,
        my_NoteWarning: item?.my_NoteWarning,
        my_VisibWarning: item?.my_VisibWarning,
    });
};

export const buildDichiarSostitFormArray = (fb: FormBuilder, myVerbale: MyVerbale, form: FormGroup) => {
    const elDichiarSostit = myVerbale?.my_SezioneI__Rilevazione?.my_DatiIdentificativi?.my_DichiarSostit?.my_ElDichiarSostit;
    rebuildFormArray(fb, elDichiarSostit, form, `${formPaths.datiIdentificativi}.my_DichiarSostit.my_ElDichiarSostit`, buildDichiarSostitGroup);
};

export const buildDichiarSostitGroup = (fb: FormBuilder, item?: MyElDichiarSostitEntity): FormGroup => {
    return fb.group({
        my_DichiarazioneSostitutiva: item?.my_DichiarazioneSostitutiva ?? '',
    });
};
